import React from 'react';

import { ColumnHeaderSortable } from '../../DataTable/index.jsx';

import Column from './base.jsx';


var columnOptions = {
  id: 'a',
  title: 'Collection'
};


class HeaderColumn extends ColumnHeaderSortable {
  get id() {
    return columnOptions.id;
  }

  get title() {
    return columnOptions.title;
  }
}


class DetailColumn extends React.Component {
  render() {
    return (
      <th>
        <a href={this.props.row.permalink} className="d-flex">
          <img src={this.props.row.image} className="cs-asset-image" />
          <span dangerouslySetInnerHTML={{ __html: this.props.row.title }} />
        </a>
      </th>
    );
  }
}


class Title extends Column {
  get id() {
    return columnOptions.id;
  }

  /**
   * This column must always be displayed
   */
  get isConfigurable() {
    return false;
  }

  get title() {
    return columnOptions.title;
  }

  get DetailColumn() {
    return DetailColumn;
  }

  get HeaderColumn() {
    return HeaderColumn;
  }
}


export default Title;

